// extracted by mini-css-extract-plugin
export default {"root":"typingEffect_root__aC2Ic","icon":"typingEffect_icon__oAp6h"};